import { useEffect, useState } from "react";
import { getArrayIsNotEmpty } from "../../../SharedComponents/utils/helpers/getArrayIsNotEmpty";
import { getFormatedCarName } from "../../utils/helpers/userCarHelpers/getFormatedCarName";
import { FontEnum } from "../../../SharedComponents/utils/enums/FontEnum";
import { getFallbackMakeLogoImage } from "../../utils/helpers/userCarHelpers/getFallbackMakeLogoImage";

const CarImageVisualizer = ({
    car,
    includeDesc = true
}) => {
    const carMake = car.Make.name;
    const images = car.UserCarImages;

    const isNotEmpty = getArrayIsNotEmpty(images);

    const [selectedImage, setSelectedImage] = useState(null);


    useEffect(() => {

        if (isNotEmpty) {
            const firstImage = images[0];
            setSelectedImage(firstImage);
        }

        else {
            const image = getFallbackMakeLogoImage(carMake);
            setSelectedImage(image);
        };
    }, []);


    if (selectedImage === null) {
        return null;
    };


    const GetOtherImageComponent = (image, index) => {

        const handleClick = () => {
            setSelectedImage(image);
        };

        return (
            <div
                key={index}
                onClick={() => handleClick()}
                style={styles.smallImageContainer}
            >
                <img
                    src={image}
                    style={styles.smallImageStyle}
                />
            </div>
        );
    };

    const getSelectedImageStyle = () => {
        if (isNotEmpty) {
            return styles.selectedImageContainer;
        }

        else {
            return styles.selectedLogoImageContainer
        };
    };

    const getCarDesc = () => {
        const title = car.title;
        const makeAndModel = `${getFormatedCarName(car.Make.name)} ${getFormatedCarName(car.Model.name)}`;
        const engine = car.Motor.name;

        return `${title} • ${makeAndModel} • ${engine}`;
    };

    return (
        <div>
            <div style={getSelectedImageStyle()}>
                <img
                    src={selectedImage}
                    style={styles.selectedImageStyle}
                />


                {includeDesc && (
                    <div style={styles.descriptionContainer}>
                        <p style={styles.descriptionText}>
                            {getCarDesc()}
                        </p>
                    </div>
                )}
            </div>


            {isNotEmpty && (
                <div style={styles.smallImagesRow}>
                    {images.map((image, index) => {
                        return GetOtherImageComponent(image, index);
                    })}
                </div>
            )}

        </div>
    );
};


export default CarImageVisualizer;

const styles = {
    selectedImageContainer: {
        position: 'relative',
        width: 300,
        height: 300,
        border: "1px solid #CBD5E1",
        borderRadius: 8,
    },
    selectedLogoImageContainer: {
        position: 'relative',
        width: 300,
        height: 300,
        border: "1px solid #CBD5E1",
        borderRadius: 8,
        background: "linear-gradient(to bottom, transparent 50%, rgba(0,0,0,0.7) 100%)"
    },
    selectedImageStyle: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: 8
    },
    smallImagesRow: {
        marginTop: 15,
        display: 'flex',
        alignItems: 'center',
        width: 'max-content',
        gap: 10
    },
    smallImageContainer: {
        cursor: 'pointer',
        width: 75,
        height: 75,
        border: "1px solid #CBD5E1",
        borderRadius: 8,
    },
    smallImageStyle: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: 8
    },
    descriptionContainer: {
        position: 'absolute',
        bottom: 14,
        left: 14,
        right: 14
    },
    descriptionText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "24px",
        color: "rgba(255, 255, 255, 0.87)"
    }
};